<template>
    <v-card flat class="mb-10">
        <div
            class="d-flex align-center justify-space-between px-3 pt-3 font-weight-600 font-size-18 border-bottom pb-3 mt-5"
        >
            <div>Data Aktivitas Konsul</div>
        </div>

        <div class="d-flex px-3 py-4 gap-10 border-bottom">
            <v-select
                v-model="search_category"
                :items="filter"
                item-text="label"
                item-value="value"
                placeholder="Filter"
                outlined
                dense
                hide-details
                style="max-width: 20%"
            ></v-select>

            <v-text-field
                v-model="search_value"
                placeholder="Ketik kata kunci dan tekan enter"
                dense
                outlined
                small
                hide-details
                append-icon="mdi-magnify"
                @keyup.enter="onSearchData(1)"
            ></v-text-field>

            <v-select
                v-model="filter_status"
                :items="list_filter_status"
                item-text="label"
                item-value="value"
                placeholder="Pilih Status"
                outlined
                dense
                hide-details
                style="max-width: 15%"
                @change="onSearchData(1)"
            ></v-select>

            <!-- <v-btn depressed color="blew" dark height="39"> Filter </v-btn> -->

            <!-- <v-select
                v-model="search_sort_type"
                :items="sort_type"
                item-text="label"
                item-value="value"
                placeholder="Sort Type"
                outlined
                dense
                hide-details
                style="max-width: 15%"
                @change="onSearchData(1)"
            ></v-select> -->
        </div>

        <v-data-table
            v-model="datatable"
            :headers="headers"
            :items="data"
            item-key="id"
            :server-items-length="totalItems"
            :items-per-page="itemsPerPage"
            :footer-props="{
                'items-per-page-options': [10, 20, 50],
            }"
            :page="page"
            @update:page="onSearchData"
            @update:items-per-page="onUpdatePerPages"
            no-data-text="Data konsultan tidak tersedia"
        >
            <template v-slot:item.action="{ item }">
                <v-menu offset-y transition="slide-y-transition">
                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-list>
                            <v-list-item-group>
                                <v-list-item
                                    v-on:click="viewChatDetail(item.id)"
                                >
                                    <v-list-item-title
                                        class="d-flex align-center gap-10"
                                    >
                                        <v-icon color="blew" class="menu-icon">
                                            mdi-message-outline
                                        </v-icon>
                                        Detail Chat
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item
                                    v-on:click="openDialogTimeActive(item)"
                                >
                                    <v-list-item-title
                                        class="d-flex align-center gap-10"
                                    >
                                        <v-icon color="blew" class="menu-icon">
                                            mdi-timer-refresh-outline
                                        </v-icon>
                                        Update Active Time
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item
                                    v-on:click="updateSyncActiveTime(item)"
                                >
                                    <v-list-item-title
                                        class="d-flex align-center gap-10"
                                    >
                                        <v-icon color="blew" class="menu-icon">
                                            mdi-timetable
                                        </v-icon>
                                        Sync Active Time
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card>
                </v-menu>
            </template>

            <template v-slot:item.detail="{ item }">
                <div class="py-3">
                    <div class="font-size-12 grey--text">Siswa</div>
                    <div>{{ item.student_name }}</div>

                    <div
                        v-if="item.teacher_name"
                        class="font-size-12 grey--text mt-3"
                    >
                        Konsultan
                    </div>
                    <div>{{ item.teacher_name }} - {{ item.subject_name }}</div>
                </div>
            </template>

            <template v-slot:item.consul_time="{ item }">
                <div class="py-3">
                    <div>
                        {{
                            $moment(item.date)
                                .tz("Asia/Jakarta")
                                .format("YYYY-MM-DD HH:mm")
                        }}
                    </div>

                    <div class="mt-2">
                        <div class="font-size-12 grey--text">Waktu Mulai</div>
                        <div>
                            {{ timeFormat(item.start_time) }}
                        </div>
                    </div>

                    <div class="mt-2">
                        <div class="font-size-12 grey--text">Waktu Selesai</div>
                        <div>
                            {{ timeFormat(item.end_time) }}
                        </div>
                    </div>
                </div>
            </template>

            <template v-slot:item.status="{ item }">
                <v-chip
                    v-if="item.status === 'finished'"
                    class="font-weight-600"
                    small
                    color="#e2f5ea"
                    text-color="#27ae60"
                >
                    Finished
                </v-chip>

                <v-chip
                    v-if="item.status === 'waiting'"
                    class="font-weight-600"
                    small
                >
                    Waiting
                </v-chip>

                <v-chip
                    v-if="item.status === 'started'"
                    class="font-weight-600"
                    small
                >
                    Started
                </v-chip>

                <v-chip
                    v-if="item.status === 'request'"
                    class="font-weight-600"
                    small
                    color="#e2f5ea"
                    text-color="#00cf3f"
                >
                    Request
                </v-chip>

                <v-chip
                    v-if="item.status === 'timeout'"
                    class="font-weight-600"
                    small
                    color="#fbefb2"
                    text-color="#f2af17"
                >
                    Timeout
                </v-chip>

                <v-chip
                    v-if="item.status === 'canceled'"
                    class="font-weight-600"
                    small
                    color="#ffcccf"
                    text-color="#eb3123"
                >
                    Canceled
                </v-chip>

                <v-chip
                    v-if="item.status === 'interrupted'"
                    class="font-weight-600"
                    small
                    color="#ffcccf"
                    text-color="#eb3123"
                >
                    Interrupted
                </v-chip>

                <v-chip
                    v-if="item.status === 'accepted'"
                    class="font-weight-600"
                    small
                    color="#e2f5ea"
                    text-color="#27ae60"
                >
                    Accepted
                </v-chip>
            </template>

            <template v-slot:item.active_time="{ item }">
                <div class="font-size-12 grey--text">DB Active Time</div>
                <div
                    class="font-weight-bold font-size-16"
                    :style="`color:${item.row_color_status}`"
                >
                    {{
                        parseInt(item.total_active_time) > 0
                            ? item.total_active_time
                            : "0.00"
                    }}
                </div>

                <div class="font-size-12 grey--text mt-3">Real Active Time</div>
                <div
                    class="font-weight-bold font-size-16"
                    :style="`color:${item.row_color_status}`"
                >
                    {{ item.real_time_active }}
                </div>
            </template>

            <template v-slot:item.session="{ item }">
                <div class="font-size-12 grey--text">Durasi Konsul</div>
                <div class="font-weight-bold font-size-16">
                    {{
                        parseInt(item.consul_duration) > 0
                            ? item.consul_duration.toFixed(2)
                            : "0.00"
                    }}
                </div>

                <div class="font-size-12 grey--text mt-3">Jumlah Sesi</div>
                <div class="font-weight-bold font-size-16">
                    {{
                        parseInt(item.total_session) > 0
                            ? item.total_session
                            : "0.00"
                    }}
                </div>
            </template>

            <template v-slot:no-results>
                <div class="text-center">
                    <p class="mt-2">Hasil pencarian tidak ditemukan.</p>
                </div>
            </template>
        </v-data-table>

        <v-dialog v-model="dialogFormTimeActive" max-width="300" scrollable>
            <v-card>
                <v-card-title class="font-size-16">
                    Update Total Active Time
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-text-field
                            v-model="total_active_form"
                            class="mt-3"
                            label="Total Active Time"
                            maxlength="8"
                            outlined
                            dense
                            :rules="[onlyNumberAndDot]"
                        />
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer />
                    <v-btn
                        color="#f7f8fa"
                        depressed
                        @click="dialogFormTimeActive = false"
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        color="blew"
                        depressed
                        dark
                        :loading="loading_update"
                        @click="updateActiveTime()"
                    >
                        Simpan
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <app-spinner v-if="loading" />
    </v-card>
</template>

<script>
import axios from "axios";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import firebase from "firebase";

export default {
    name: "consul-active-time",

    components: {
        AppSpinner,
    },

    data() {
        return {
            dialogFormTimeActive: false,
            loading: false,
            loading_update: false,
            datatable: null,
            data: [],
            search_category: null,
            search_value: null,
            search_sort_by: null,
            search_sort_type: null,
            headers: [
                { text: "Aksi", value: "action", sortable: false, width: 30 },
                {
                    text: "Detail",
                    value: "detail",
                    sortable: false,
                    width: 180,
                },
                { text: "Waktu", value: "consul_time", width: 150 },
                {
                    text: "Status Konsultasi",
                    value: "status",
                    sortable: false,
                    align: "center",
                    width: 100,
                },
                {
                    text: "Waktu Efektif",
                    value: "active_time",
                    sortable: false,
                    align: "right",
                    width: 120,
                },
                // {
                //     text: "Real Waktu Efektif",
                //     value: "real_time_active",
                //     sortable: false,
                //     align: "right",
                //     width: 120,
                // },
                {
                    text: "Sesi",
                    value: "session",
                    sortable: false,
                    align: "right",
                    width: 100,
                },
            ],
            data: [],
            filter: [
                {
                    value: "teacher_name",
                    label: "Nama Teacher",
                },
                {
                    value: "student_name",
                    label: "Nama Siswa",
                },
                {
                    value: "subject",
                    label: "Mapel",
                },
                {
                    value: "grade",
                    label: "Kelas",
                },
            ],
            sort_by: [
                {
                    value: "createdAt",
                    label: "Created Date",
                },
            ],
            sort_type: [
                {
                    value: "asc",
                    label: "Lama ke Baru",
                },
                {
                    value: "desc",
                    label: "Baru ke Lama",
                },
            ],
            filter_status: null,
            list_filter_status: [
                {
                    value: "finished",
                    label: "Finished",
                },
                {
                    value: "started",
                    label: "Started",
                },
                {
                    value: "canceled",
                    label: "Canceled",
                },
                {
                    value: "timeout",
                    label: "Timeout",
                },
                {
                    value: "waiting",
                    label: "Waiting",
                },
                {
                    value: "interrupted",
                    label: "Interrupted",
                },
            ],
            params: {
                page: 1,
                limit: 10,
                sort_by: null,
                sort_type: null,
            },
            totalItems: 0,
            itemsPerPage: 10,
            page: 1,
            dialogDetail: false,
            config_data: null,
            detail: {},
            selected_items: [],
            params_update: [],
            total_active_form: 0,
        };
    },

    async mounted() {
        // getChatList membaca config_data.idle_time, jadi tabel sengaja tidak
        // diisi kalau config gagal dimuat: lebih baik kosong daripada
        // menampilkan perhitungan waktu aktif yang salah.
        if (!(await this.getAndroidConfig())) return;

        await this.fetchData();
    },

    watch: {},

    methods: {
        onUpdatePerPages(val) {
            this.itemsPerPage = val;
            this.onSearchData(1);
        },

        onSearchData(newPage) {
            this.params = {
                page: newPage || 1,
                limit: this.itemsPerPage || 0,
                sort_by: this.search_sort_by || null,
                sort_type: this.search_sort_type || null,
                status: this.filter_status,
            };

            this.params[this.search_category] = this.search_value;
            this.page = newPage;

            this.fetchData();
        },

        async fetchData() {
            const url = `${process.env.API_BASE_URL}konsul/admin/list-konsul`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            const self = this;
            self.loading = true;

            try {
                const response = await axios.get(url, {
                    params: self.params,
                    ...options,
                });

                var data = response.data.list_report || [];
                self.totalItems = response.data.total_item || 0;

                var row_data = await Promise.all(
                    data.map(async (item) => {
                        const chatList = await self.getChatList(item);

                        return {
                            ...item,
                            real_time_active: chatList.active_time,
                            row_color_status: chatList.row_color,
                        };
                    })
                );

                self.data = row_data;
            } catch (error) {
                console.error("Fetch Data Error:", error);
            } finally {
                self.loading = false;
            }
        },

        async getChatList(item) {
            const inputDate = this.$moment(item.date);
            const targetDate = this.$moment("2025-03-07");
            var config_idle_time = 1;
            var rowColor = null;

            if (inputDate.isBefore(targetDate, "day")) {
                config_idle_time = 1;
            } else {
                config_idle_time = this.config_data.idle_time;
            }

            try {
                const snapshot = await firebase
                    .firestore()
                    .collection("chat_rooms")
                    .doc(`CHAT_${item.id}`)
                    .collection("message")
                    .orderBy("created_at")
                    .get();

                let row = [];
                const idleThresholdMilis = config_idle_time * 60000;

                let activeTime = 0;
                const listTimeChat = [];

                snapshot.forEach((doc) => {
                    const data = doc.data();
                    row.push(data);
                    listTimeChat.push(data.created_at);
                });

                if (listTimeChat.length > 1) {
                    const sortedTimeChat = listTimeChat.sort((a, b) => a - b);
                    let sessionStart = sortedTimeChat[0];

                    for (let i = 1; i < sortedTimeChat.length; i++) {
                        const diff = sortedTimeChat[i] - sortedTimeChat[i - 1];

                        if (diff < idleThresholdMilis) {
                            activeTime += diff;
                        } else {
                            activeTime += idleThresholdMilis;
                        }

                        sessionStart = sortedTimeChat[i];
                    }
                }

                activeTime = Math.floor(activeTime / 1000);
                activeTime = (activeTime / 60).toFixed(2);

                if (Math.abs(activeTime - item.total_active_time) >= 1) {
                    rowColor = "red";
                }

                return {
                    active_time: activeTime,
                    row_color: rowColor,
                };
            } catch (error) {
                console.log("Fetch Messages Error:", error);
                return [];
            }
        },

        async getAndroidConfig() {
            try {
                const response = await this.$alioss.get(
                    `/config/config.android`,
                );
                this.config_data = JSON.parse(response.res.data);

                return true;
            } catch (error) {
                this.$store.commit("showAlert", {
                    message: `Gagal memuat konfigurasi konsul`,
                    submessage: error.message,
                    type: "error",
                });

                return false;
            }
        },

        viewChatDetail(id) {
            let routeData = this.$router.resolve({
                path: "/konsul/chat",
                query: {
                    cr_id: id,
                },
            });
            window.open(routeData.href, "_blank");
        },

        openDialogTimeActive(item) {
            this.dialogFormTimeActive = true;
            this.selected_items = item;
            this.total_active_form = item.total_active_time;
        },

        updateActiveTime() {
            if (this.$refs.form.validate()) {
                var total_minutes = this.total_active_form * 60;

                this.params_update.push({
                    cr_id: this.selected_items.id,
                    total_active_time: total_minutes,
                });

                this.updateActiveTimeProcess();
            }
        },

        updateSyncActiveTime(data) {
            var total_minutes = data.real_time_active * 60;

            this.params_update.push({
                cr_id: data.id,
                total_active_time: total_minutes,
            });

            this.updateActiveTimeProcess();
        },

        async updateActiveTimeProcess() {
            const url = `${process.env.API_BASE_URL}konsul/admin/multiple-update-active-time`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            const self = this;
            self.loading_update = true;

            try {
                const response = await axios.post(
                    url,
                    this.params_update,
                    options
                );
            } catch (error) {
                console.error("Fetch Data Error:", error);
            } finally {
                self.params_update = [];
                self.dialogFormTimeActive = false;
                self.loading_update = false;
                self.fetchData();
            }
        },

        onlyNumberAndDot(value) {
            return /^[0-9.]*$/.test(value) || "Hanya boleh angka dan titik";
        },

        timeFormat(date) {
            var datex = date
                ? this.$moment(date).tz("Asia/Jakarta").format("HH:mm")
                : "-";

            if (datex === "Invalid date") {
                datex = date.slice(-5);
            }

            return datex;
        },
    },
};
</script>

<style scoped>
.v-data-table tbody tr:hover {
    background-color: transparent !important;
    font-weight: bold !important;
}
</style>



// WEBPACK FOOTER //
// ConsulTimeActive.vue?2cd117ba